const table = {
  baseStyle: {
    table: {
      borderRadius: '8px 8px 0px 0px',
      overflow: 'hidden'
    },
    th: {
      color: 'text.body',
      bgColor: 'rgba(226, 228, 233, 0.70)',
      textTransform: 'none',
      fontSize: '14px',
      fontWeight: 'normal',
      lineHeight: '142.857%',
      letterSpacing: '-0.084px',
    },
    tbody: {
      bgColor: 'white'
    },
    tr: {
      transition: 'background-color 0.2s ease',
      _hover: {
        bgColor: '#FAFAFA'
      }
    },
    td: {
      color: 'text.heading',
      fontSize: '14px',
      lineHeight: "142.857%",
      letterSpacing: "-0.084px",
      '.chakra-avatar': {
        verticalAlign: 'middle',
        mr: '12px'
      },
      span: {
        fontSize: '12px',
        color: '#525866'
      }
    }
  },
  variants: {
    simple: {

    }
  },
  sizes: {
    md: {
      th: {
        px: '15px',
        py: '10px',
        fontSize: '14px'
      },
      td: {
        px: '15px',
        py: '10px',
        lineHeight: '100%'
      }
    }
  }
};

export default table;
